'use strict';
(function ($, Drupal, window, document) {

  $(document).ready(function () {
    // Skip Nav with tabindex fix
    $(".skip-link").click(function (event) {

      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = "#" + this.href.split('#')[1];

      // Setting 'tabindex' to -1 takes an element out of normal
      // tab flow but allows it to be focused via javascript
      $(skipTo).attr('tabindex', -1).on('blur focusout', function () {

        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr('tabindex');

      }).focus(); // focus on the content container
    });

    $('#nav-mobile-toggle').on('click', function () {
        $(this).toggleClass('is-open');
        $('.header-navigation').toggleClass('is-open').slideToggle();
    });

    if ($('.homes-filters').length) {
      var $homesGrid = $('.inventory-list').isotope({
        itemSelector: '.col',
        layoutMode: 'fitRows',
        getSortData: {
          builder: function (itemElem) {
            return parseInt($('.card-inventory', itemElem).data('builder'));
          },
          price: function (itemElem) {
            return parseInt($('.card-inventory', itemElem).data('price'));
          },
          lot: function (itemElem) {
            return parseInt($('.card-inventory', itemElem).data('lot'));
          }
        }
      });

      $('.homes-sort-button').on('click', function (e) {
        e.preventDefault();
        var sort = $(this).data('sort');
        $('.homes-sort-button').not(this).removeClass('is-active sort-asc sort-desc');

        $(this).addClass('is-active');
        var sortAsc = true;

        if ($(this).hasClass('sort-asc')) {
          sortAsc = false;
          $(this).removeClass('sort-asc');
          $(this).addClass('sort-desc');
        } else {
          $(this).addClass('sort-asc');
          $(this).removeClass('sort-desc');
        }

        $homesGrid.isotope({
          sortBy: sort,
          sortAscending: sortAsc
        });
      });

      function runfilter(val, attr) {
        $homesGrid.isotope({
          filter: function () {
            if (!val) return '*';
            return $('.card-inventory', this).data(attr) == val;
          }
        });
      }

      $('#homes-filter-builder').on('change', function (e) {
        e.preventDefault();
        var filterChoice = $(this).val();
        runfilter(filterChoice, 'builder');
      });

      $('#homes-filter-lot').on('change', function (e) {
        e.preventDefault();
        var filterChoice = $(this).val();
        runfilter(filterChoice, 'lot');
      });

      $('#homes-filter-price').on('change', function (e) {
        e.preventDefault();
        var filterChoice = $(this).val();
        $homesGrid.isotope({
          filter: function () {
            if (!filterChoice) return '*';
            return parseInt($('.card-inventory', this).data('price')) <= filterChoice;
          }
        })
      });
    }

    // #DEV - REMOVE LATER
    $('.site-logo').attr('href','/home');

  });


})(jQuery, Drupal, this, this.document);
